import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import { AuthProvider } from './context/AuthContext'
import Spinner from './components/common/Spinner'

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const ReestablecerContra = React.lazy(() => import('./views/pages/reestablecer-contra/ReestablecerContra'))

class App extends Component {

  render() {
    return (
      <HashRouter>
        <Suspense fallback={<Spinner/>}>
          <AuthProvider>
            <Routes>
              <Route exact path="/login" name="Login" element={<Login />} />
              <Route exact path="/404" name="Page 404" element={<Page404 />} />
              <Route exact path="/500" name="Page 500" element={<Page500 />} />
              <Route exact path="/reestablecer-contra" name="Reestablecer" element={<ReestablecerContra/>} />
              <Route path="*" name="Portal" element={<DefaultLayout />} />
            </Routes>
          </AuthProvider>
        </Suspense>
      </HashRouter>
    )
  }
}

export default App
